// color swatch directive
//
//   <color-swatch color="#8a7d0a" label="foo bar" />

const BASE_STYLE = {
  display: 'inline-block',
  width: '100px',
  backgroundColor: '--passed-in--',
  color: '#fff',
  textShadow: '0 0 2px rgba(0,0,0,0.3)',
  padding: '3px',
  textAlign: 'center',
  border: '1px solid #ccc',
  borderRadius: '4px',
};

let module = angular.module('app.directives');

module.directive('colorSwatch', () => {
  'ngInject';

  return {
    restrict: 'E',
    scope: { color: '=', label: '=', extraStyle: '=' },
    template: `
      <span ng-style="style">{{label}}</span>
    `,
    link: (scope, element) => {
      function computeStyle() {
        scope.style = _.extend({}, BASE_STYLE, scope.extraStyle || {}, {
          backgroundColor: scope.color,
        });
      }

      computeStyle();
      scope.$watchCollection(() => [scope.color, scope.label], computeStyle);
    },
  };
});



// WEBPACK FOOTER //
// ./app/directives/color-swatch.js